import { jsx as _jsx } from "react/jsx-runtime";
import { SocialsProspects as UISocialsProspects } from "@bluframe/mightychroma-mightytool-ui";
const Prospects = (props) => _jsx(UISocialsProspects, { ...props });
export default Prospects;
